import { FC } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import { useFormat } from 'helpers/hooks/useFormat';

type AccordionButtonProps = {
  open: boolean;
  toggleAccordion: () => void;
};

const AccordionButton: FC<AccordionButtonProps> = ({ open, toggleAccordion }) => {
  const { formatMessage: formatOrdersMessage } = useFormat({ name: 'orders' });

  const accordionContentClassNames = useClassNames([
    'flex w-full justify-between border-t py-16',
    open ? 'border-t' : '',
  ]);

  const arrowClassNames = useClassNames([open ? 'rotate-180 transform' : '', 'transition mr-8']);

  return (
    <div>
      <div className={accordionContentClassNames} onClick={toggleAccordion}>
        <Typography className="text-[#137e57]">
          {formatOrdersMessage({
            id: 'your.order',
            defaultMessage: 'Shipment Details',
          })}
        </Typography>

        <div className="flex">
          <ChevronDownIcon width={20} strokeWidth={1.5} className={arrowClassNames} />
        </div>
      </div>
    </div>
  );
};

export default AccordionButton;
